// extracted by mini-css-extract-plugin
export default {"new":"NewItems_new__w17bV"};